import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import { ReactComponent as CalendarIcon } from "../../assets/General/Calendar.svg";
import s from "./MuiDatePicker.module.css";

type MuiDatePickerProps = {
  value: Dayjs | undefined;
  setValue: (value: Dayjs | null) => void;
  label?: string;
};

const MuiDatePicker = ({ value, setValue, label }: MuiDatePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        className={s.datePicker}
        value={value}
        onChange={(value: Dayjs | null) => setValue(value)}
        //@ts-expect-error
        components={{
          OpenPickerIcon: CalendarIcon,
        }}
        views={["year", "month", "day"]}
        label={label}
        sx={{
          "& .MuiPickersDay-root .Mui-selected": {
            backgroundColor: "red",
            color: "white",
          },
          "& .MuiPickersDay-root.Mui-selected:hover": {
            backgroundColor: "darkred",
          },
          "& .MuiOutlinedInput-root": {
            width: "100%",
          },
        }}
        slotProps={{
          textField: {
            InputLabelProps: {
              sx: {
                color: "white", // цвет текста
                fontSize: "15px", // размер шрифта
                top: !value ? "-7px" : "-14px", // сдвиг вверх
                "&.Mui-focused": {
                  color: "white", // цвет при фокусе
                },
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default MuiDatePicker;
